import React from "react";
import "../style/Footer.css";

const Footer = () => {
  return (
    <div className="footer_hero">
      <div className="footer_elem">
        <h4>title</h4>
        <p>helllo my name is arijit panda.</p>
      </div>
      <div className="footer_elem">
        <h4> quick links</h4>

        <div>home</div>
        <div>about</div>
        <div>me</div>
        <div>go to hell</div>
      </div>
      <div className="footer_elem">jiwan andhar</div>
    </div>
  );
};

export default Footer;
